module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8003.33c44fe3.png";